import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { faTrash } from "@fortawesome/pro-light-svg-icons";
import { AddToolTip } from "../../../components";
import {
  deleteInputPlanGroupOutputById,
  deletePlanGroupInOutput,
} from "../../../services";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { UpdateApiMappings } from "../../../contexts";

const MappedPlanGroupCard = ({
  item,
  onPlanGroupClick,
  savedPlanGroups,
  setSavedPlangroups,
  setAddedPlanGroups,
  mapType,
  dispatch,
}) => {
  const DeletePlanGroup = (Id, planGroupId) => {
    if (Id == 0) {
      var savedPlanGroup = savedPlanGroups.filter(
        (item) => item.planGroupId !== planGroupId
      );
      setSavedPlangroups(savedPlanGroup);
      setAddedPlanGroups(savedPlanGroup);
    }
    if (mapType == 1) {
      deleteInputPlanGroupOutputById(Id).then((res) => {
        if (res) {
          var savedPlanGroup = savedPlanGroups.filter(
            (item) => item.planGroupId !== planGroupId
          );
          setSavedPlangroups(savedPlanGroup);
          setAddedPlanGroups(savedPlanGroup);
          dispatch(
            UpdateApiMappings({
              modelName: "planGroupProfiles",
              data: savedPlanGroup,
            })
          );
        }
      });
    } else {
      deletePlanGroupInOutput(Id).then((res) => {
        if (res) {
          var savedPlanGroup = savedPlanGroups.filter(
            (item) => item.planGroupId !== planGroupId
          );
          setSavedPlangroups(savedPlanGroup);
          setAddedPlanGroups(savedPlanGroup);
          dispatch(
            UpdateApiMappings({
              modelName: "outputPlanGroupProfileMappings",
              data: savedPlanGroup,
            })
          );
        }
      });
    }
  };
  return (
    <div
      className="col-md-4 p-2"
      onClick={() => onPlanGroupClick(item.planGroupId)}
    >
      <div className="mappedPlanGroupCard">
        <p className="ft-16 mb-3 fw-500">
          <AddToolTip name={item.planGroupName} />
        </p>
        <p className="ft-16 fw-500 mb-1">{item.count}</p>
        <div className="d-flex justify-content-space-between">
          <p className="ft-14 grey-text">Mapped plans</p>
          <FontAwesomeIcon
            color="red"
            className="payroll-delete"
            icon={faTrashAlt}
            onClick={(evt) => {
              evt.stopPropagation();
              DeletePlanGroup(item.id, item.planGroupId);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MappedPlanGroupCard;
